import isBlank from 'is-blank'
import FormSection from './FormSection'

export default {
  components: {
    FormSection
  },
  props: {
    direction: {
      type: String,
      default: () => 'horizontal',
      validator: value => ['horizontal', 'vertical'].includes(value)
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    error: {
      type: String,
      default: () => ''
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
    label: {
      type: String,
      default: () => ''
    },
    labelVisible: {
      type: Boolean,
      default: () => false
    },
    fullWidth: {
      type: Boolean,
      default: () => false
    },
    name: {
      type: String,
      required: () => true
    },
    hint: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    hasError () {
      return !isBlank(this.error)
    },
    hasLabel () {
      return !isBlank(this.label)
    },
    hasHint () {
      return !isBlank(this.hint)
    }
  },
  methods: {
    handleInputValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/InputCommon.js